export enum OAUTH_PROVIDER_CHOICES {
    google = 'Google',
    facebook = 'Facebook',
    tradexa = 'tradexa',
    /* saucony = 'saucony', */
    consumer = 'consumer',
}